/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum FILTER_NAME_VALUES {
  EQUALS = "equals",
  NOT_EQUALS = "not-equals",
  CONTAINS = "contains",
  NOT_CONTAINS = "not-contains",
  STARTS_WITH = "starts-with",
  ENDS_WITH = "ends-with",
  GREATER = "greater",
  GREATER_EQUAL = "greater-equal",
  LESS = "less",
  LESS_EQUAL = "less-equal",
  IS_NULL = "is-null",
  IS_NOT_NULL = "is-not-null",
  BETWEEN = "between",
}
